import { useMutation } from '@tanstack/react-query'

import { Answer } from '@/types/answer'

import { updateAnswerById } from './services/updateAnswerById'

export const useUpdateAnswerById = () => {
  const mutation = useMutation({
    mutationFn: async (data: Partial<Answer>) => await updateAnswerById(data),
  })

  const updateAnswerByIdReq = async (data: Partial<Answer>) => {
    return mutation.mutateAsync(data)
  }

  return {
    updateAnswerById: updateAnswerByIdReq,
    ...mutation,
  }
}
